package com.eladfinish.bible.contest.navigation

import androidx.navigation.NavController

fun NavController.navigateByCommand(command: NavigationCommand.Navigate) {
    val options = command.navOptions
    if (options != null) {
        navigate(route = command.destination, builder = options)
    } else {
        navigate(route = command.destination)
    }
}
